/**
 * SidebarWrapper Component
 *
 * Feature flag wrapper that switches between legacy and new Sidebar implementations.
 * Adapts legacy props to new Sidebar API.
 *
 * Toggle via: localStorage.setItem('FF_NEW_NAV', 'true') or Ctrl+Shift+N
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FEATURE_FLAGS } from '../../config/featureFlags';
import LegacySidebar from './Sidebar';

// New navigation components (lazy loaded to avoid bundle impact when flag is off)
const NewSidebarComponents = React.lazy(() =>
  import('./NewSidebarAdapter').then(module => ({ default: module.NewSidebarAdapter }))
);

/**
 * SidebarWrapper - switches between legacy and new Sidebar based on feature flag
 */
function SidebarWrapper({
  mobileOpen,
  handleDrawerToggle,
  sidebarOpen,
  handleSidebarToggle,
}) {
  // Use legacy sidebar when feature flag is off
  if (!FEATURE_FLAGS.USE_NEW_NAVIGATION) {
    return (
      <LegacySidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        sidebarOpen={sidebarOpen}
        handleSidebarToggle={handleSidebarToggle}
      />
    );
  }

  // Use new sidebar when feature flag is on
  return (
    <React.Suspense fallback={<SidebarSkeleton />}>
      <NewSidebarComponents
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        sidebarOpen={sidebarOpen}
        handleSidebarToggle={handleSidebarToggle}
      />
    </React.Suspense>
  );
}

/**
 * Simple skeleton while new sidebar loads
 */
function SidebarSkeleton() {
  return (
    <div
      style={{
        width: 250,
        height: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    />
  );
}

SidebarWrapper.propTypes = {
  mobileOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  handleSidebarToggle: PropTypes.func.isRequired,
};

export default SidebarWrapper;
